export enum CalendarEventTypes {
  Availability = "availability",
  ConsultationAppointment = "consultation_appointment",
  ConsultationIntro = "consultation_intro",
  Online = "online",
  Unknown = "unknown_type",
}
